import type {
  AssignmentTypeFilter,
  ClassworkCreatedByFilter,
  ClassworkStatusFilter,
  SelectOption
} from '../types';

// Shared by the diagnostics + assignments classwork lists.
export const STATUS_FILTER_OPTIONS: ReadonlyArray<SelectOption<ClassworkStatusFilter>> = [
  {value: 'all', label: 'All'},
  {value: 'open', label: 'Open'},
  {value: 'scheduled', label: 'Scheduled'},
  {value: 'closed', label: 'Closed'}
];

export const CREATED_BY_FILTER_OPTIONS: ReadonlyArray<SelectOption<ClassworkCreatedByFilter>> = [
  {value: 'all', label: 'All'},
  {value: 'you', label: 'You'},
  {value: 'someoneElse', label: 'Someone else'}
];

export const ASSIGNMENT_TYPE_FILTER_OPTIONS: ReadonlyArray<SelectOption<AssignmentTypeFilter>> = [
  {value: 'all', label: 'All'},
  {value: 'assignment', label: 'Assignment'},
  {value: 'exam', label: 'Assessment'}
];
